
namespace GeniuzPOS.SalePromoCamp {
    import fld = PsPromoActiveHdRow.Fields
        @Serenity.Decorators.registerClass()
        export class PsPromoActiveHdGrid extends Serenity.EntityGrid<PsPromoActiveHdRow, any> {
            protected getColumnsKey() { return PsPromoActiveHdColumns.columnsKey; }
            protected getDialogType() { return PsPromoActiveHdDialog; }
            protected getIdProperty() { return PsPromoActiveHdRow.idProperty; }
            protected getInsertPermission() { return PsPromoActiveHdRow.insertPermission; }
            protected getLocalTextPrefix() { return PsPromoActiveHdRow.localTextPrefix; }
            protected getService() { return PsPromoActiveHdService.baseUrl; }
    
            constructor(container: JQuery) {
                super(container);
            }
            protected getButtons() {
                var buttons = super.getButtons();
    
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
                
                buttons.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );            
                return buttons;
            }
            protected createToolbarExtensions() {
                super.createToolbarExtensions();
        
                this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                    
                var groupingMixin = new Serenity.DraggableGroupingMixin({
                    grid: this
                });
        
                // setting ShipCountry, ShipCity columns as initially grouped for this sample
                // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
                // in OrderColumns.cs instead (recommended way)
                groupingMixin.plugin.setDroppedGroups(["  "]);
            }
            protected getSlickOptions() {
                var opt = super.getSlickOptions();
                // need to turn grouping panel ON for drag drop grouping to work properly
                opt.groupingPanel = true;
                return opt;
            }
            // protected getQuickFilters(): Serenity.QuickFilter<Serenity.Widget<any>, any>[] {
    
            //     let filters = super.getQuickFilters();
            //     // Q.first(filters, x => x.field == fld.PromoApproveFg).init = w => {
            //     //     (w as Serenity.EnumEditor).value = "1";
            //     //     ;
            //     // };
            //     Q.first(filters, x => x.field == fld.PromoStatus).init = w => {
            //         (w as Serenity.EnumEditor).value = "0";
            //         // Serenity.EditorUtils.setReadOnly(, true);
            //     };   
                
                
            //     return filters;
            // }
        }
    }